import { Modal, Row, Table } from "antd";
import React, { useEffect, useState } from "react";
import TableContainer from "../Table/TableContainer";
import type { SaleEntity } from "../../entities/SaleEntity";
import { numberFormatter } from "../../utility/Formatter";
import { roleDatasource } from "../../datasource/RoleDatasource";
import { useLocalStorage } from "../../hook/useLocalStorage";
import { Texts } from "../../pages/UserPage/SaleManagementPage/SaleManagementPage";
import Text from "../Text/Text";

interface Props {
  visible: boolean;
  onCancel: () => void;
  roleName: string;
}

function ModalUserList({ visible, onCancel, roleName }: Props) {
  const [company] = useLocalStorage("profile", null);
  const [userList, setUserList] = useState<SaleEntity[]>([]);

  useEffect(() => {
    const getUser = async () => {
      try {
        await roleDatasource.userInRole(company.company, roleName).then((res) => {
          setUserList(res);
        });
      } catch (error) {
        console.log(error);
      }
    };
    if (visible) {
      getUser();
    }
  }, [visible]);

  const columns: any = [
    {
      title: "ลำดับ",
      dataIndex: "key",
      key: "key",
      width: 80,
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <>
              <Texts>{index + 1}</Texts>
            </>
          ),
        };
      },
    },
    {
      title: "ชื่อ - นามสกุล",
      dataIndex: "name",
      key: "name",
      width: 350,
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <Row>
              <Texts>{row.firstname + " " + row.lastname}</Texts>&nbsp;
              <Texts>{row.nickname ? `(${row.nickname})` : null}</Texts>
            </Row>
          ),
        };
      },
    },
    {
      title: "เขต",
      dataIndex: "zone",
      key: "zone",
      width: 190,
      render: (value: any, row: any, index: number) => {
        return {
          children: <Texts>{value || "-"}</Texts>,
        };
      },
    },
    {
      title: "ตำแหน่ง",
      dataIndex: "role",
      key: "role",
      width: 150,
    },
    {
      title: "เบอร์โทรศัพท์",
      dataIndex: "telephone",
      key: "telephone",
      width: 140,
    },
    {
      title: "อีเมล",
      dataIndex: "email",
      key: "email",
    },
  ];
  return (
    <Modal open={visible} centered onCancel={onCancel} closable width={1250} footer={null}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "start",
          padding: "0px 0px 22px 0px",
        }}
      >
        <Text fontSize={20} fontWeight={700}>
          รายชื่อสมาชิก
        </Text>
        <Text fontSize={14} color='Text3'>
          ทั้งหมด {numberFormatter(userList?.length, 0) || 0} คน
        </Text>
      </div>
      <TableContainer>
        <Table
          columns={columns}
          dataSource={userList || []}
          pagination={false}
          scroll={{ y: 400 }}
        />
      </TableContainer>
    </Modal>
  );
}

export default ModalUserList;
